import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import "./App.scss";

import PreAni from "./PreAni";
import First from "./First";
import Second from "./Second";
import ThirdPage from "./ThirdPage";

interface IApp {}

interface IState {
    showAni: boolean;
}

class App extends BaseComponent<IApp, IState> {
    constructor(props: IApp) {
        super(props);
        this.state = {
            showAni: true,
        };
    }

    handleEndAni = () => {
        this.setState({
            showAni: false,
        });
    };

    render() {
        const { showAni } = this.state;
        return (
            <div className="hxzyy-page">
                {showAni ? <PreAni handleEndAni={this.handleEndAni} /> : null}
                <div className={showAni ? "page-content hidden" : "page-content"}>
                    <First />
                    <Second />
                    <ThirdPage />
                </div>
            </div>
        );
    }
}

export default App;
